import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=188d310f"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports